<template>
  <div>
    <v-select
      :items="items"
      item-title="label"
      item-value="value"
      :model-value="modelValue"
      @update:model-value="inputAge"
      variant="outlined"
      density="compact"
      hide-details
      color="primary"
    >
    </v-select>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "AgePicker",

  emits: ["update:modelValue"],

  props: {
    modelValue: {
      type: [Number, null] as PropType<number | null>,
      required: false,
      default: null,
    },
  },

  methods: {
    inputAge(value: number | null) {
      this.$emit("update:modelValue", value);
    },
  },

  data() {
    return {
      items: [
        { label: "すべて", value: null },
        { label: "0歳", value: 0 },
        { label: "1歳", value: 1 },
        { label: "2歳", value: 2 },
        { label: "3歳", value: 3 },
        { label: "4歳", value: 4 },
        { label: "5歳以上", value: 5 },
      ],
    };
  },
});
</script>
